import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";

const url =
  process.env.NODE_ENV === "production"
    ? "https://zeropa-api.herokuapp.com/"
    : "http://localhost:3001";

export const authClient = createAuthClient({
  baseURL: url, // the base url of your auth server
  fetchOptions: {
    credentials: "include", // include cookies in requests
    onError: (error) => {
      console.error("BA auth error:", error);
    },
  },
  plugins: [adminClient()],
});

export const { signUp, signIn, signOut, useSession, getSession } = authClient;
